// Pure, null-safe helpers for the "How much you buy" unit switcher. A month with no purchases has NO data object,
// so every accessor must tolerate undefined / null / partial records (missing `units`, legacy payloads without hierarchy).

export const fmtNum = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return "0";
  if (Number.isInteger(n)) return n.toLocaleString("en-GB");
  return (Math.round(n * 100) / 100).toLocaleString("en-GB", { maximumFractionDigits: 2 });
};

// Unit choices offered for a purchases payload. Falls back to one legacy quantity button when the product has no hierarchy.
export function resolveUnits(data) {
  const given = Array.isArray(data?.units) ? data.units.filter((u) => u && u.key && u.label) : [];
  if (given.length) return given.map((u) => ({ key: String(u.key), label: String(u.label), singular: String(u.singular || u.label) }));
  if (data?.base_unit) return [{ key: "__base", label: data.base_unit === "items" ? "Items" : String(data.base_unit), singular: String(data.base_unit) }];
  return [{ key: "__qty", label: data?.unit || "Units", singular: data?.unit || "unit" }];
}

// Quantity of a month / year / all-time object in the given unit (0 when the object or the unit is missing).
export function qtyOf(o, unit) {
  if (!o || !unit) return 0;
  let v;
  if (unit.key === "__base") v = o.base_quantity;
  else if (unit.key === "__qty") v = o.quantity;
  else v = o.units && typeof o.units === "object" ? o.units[unit.key] : undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function unitWord(unit, n) {
  if (!unit) return "";
  if (unit.label === unit.singular) return unit.label; // SBOX, CASE, kg, L — never pluralised
  return n === 1 ? unit.singular : unit.label.toLowerCase();
}

export const qtyText = (o, unit) => `${fmtNum(qtyOf(o, unit))} ${unitWord(unit, qtyOf(o, unit))}`.trim();

// The other unit levels of the same purchases ("3 SBOX · 12 packs"); zero levels are dropped, "" when nothing applies.
export function levelsText(o, units, current) {
  if (!o || !Array.isArray(units)) return "";
  return units.filter((u) => u && u.key !== current?.key && qtyOf(o, u) > 0).map((u) => `${fmtNum(qtyOf(o, u))} ${unitWord(u, qtyOf(o, u))}`.trim()).join(" · ");
}
